import { useCallback } from 'react';
import axios from 'axios';

const defaultTimeout = 1000 * 60 * 1; // 1 minute

export function useFetcher({ user }) {
  const fetcher = useCallback(
    async ({ method = 'GET', url, data = null, responseType, headers: extraHeaders }) => {
      // Let the browser/axios set the multipart boundary for FormData uploads.
      const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
      return await axios({
        method,
        timeout: defaultTimeout,
        url,
        headers: {
          ...(!isFormData && { 'Content-Type': 'application/json' }),
          ...(user?.accessToken && { Authorization: `Bearer ${user.accessToken}` }),
          ...extraHeaders,
        },
        ...(data && { data }),
        ...(responseType && { responseType }),
      }).then((res) => res.data);
    },
    [user]
  );

  return fetcher;
}
